import { createRouter, createWebHistory } from 'vue-router';
import BiDashboard from '~/bi/pages/bi-dashboard.vue';
import { onRouteError } from '~/common/middleware/routes.middleware';
import Dashboard from '~/dashboard/pages/dashboard.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:asset_id?',
      name: 'home',
      component: Dashboard,
    },
    {
      path: '/:asset_id?/bi-dashboard',
      name: 'bi-dashboard-home',
      component: BiDashboard,
    },
    {
      path: '/:asset_id?/bi-dashboard/public',
      name: 'bi-public-dashboard',
      component: BiDashboard,
      meta: { public: true },
    },
  ],
  scrollBehavior() {
    // always scroll to top
    return { top: 0 };
  },
});

router.onError(onRouteError);

export default router;
